
import { Component, Vue } from "vue-property-decorator";
import WorldCupComponent from "@/libs/WorldCupComponent";

@Component({})
export default class Cna extends WorldCupComponent {
  config: any;
  created() {}
}
